import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, specraButtonVariants } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
export function ConfirmDeleteDialog({ open, onOpenChange, title, description, onConfirm, isPending, readOnly, confirmLabel = 'Delete', pendingLabel = 'Deleting…' }) {
    return /*#__PURE__*/ _jsx(AlertDialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(AlertDialogContent, {
            "data-testid": Testids.deliveryShared.confirmDelete,
            children: [
                /*#__PURE__*/ _jsxs(AlertDialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(AlertDialogTitle, {
                            children: title
                        }),
                        description && /*#__PURE__*/ _jsx(AlertDialogDescription, {
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(AlertDialogFooter, {
                    children: [
                        /*#__PURE__*/ _jsx(AlertDialogCancel, {
                            className: specraButtonVariants({
                                variant: 'secondary'
                            }),
                            disabled: isPending,
                            "data-testid": Testids.deliveryShared.confirmDeleteCancel,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(AlertDialogAction, {
                            className: specraButtonVariants({
                                variant: 'danger'
                            }),
                            disabled: isPending || readOnly,
                            onClick: onConfirm,
                            "data-testid": Testids.deliveryShared.confirmDeleteOk,
                            children: isPending ? pendingLabel : confirmLabel
                        })
                    ]
                })
            ]
        })
    });
}
